import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';
import moment from 'moment';
import { mainReducers } from './mainReducers';

export const initialState = {
  items: {},
  itemsCache: {},
  pagination: {
    size: 10,
    skip: 0,
    totalItemCount: 0,
  },
};

const rootReducer = mapActionToReducer({
  default: initialState,
  ...mainReducers,
});

export default reduceReducers(rootReducer);
